import { proxy } from 'valtio';
import type { DataRequestV2 } from '~/common/types';

class EvidenceStore {
  projectRequests: { [key: string]: DataRequestV2 } = {};

  setRequests(requests: DataRequestV2[]) {
    requests.forEach((r) => {
      this.projectRequests[r.id] = r;
    });
  }

  reset() {
    this.projectRequests = {};
  }
}

const evidenceStore = proxy(new EvidenceStore());
export default evidenceStore;
